export default __webpack_public_path__ + "static/media/white.60231f00.svg";